import Comment, { CommentRefType as CommentRefTypeOriginal } from "./Comment";

export default Comment;
export type CommentRefType = CommentRefTypeOriginal;
